import React from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation, Keyboard } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import { getDarkerThemeColor, getLighterThemeColor, getUserThemeContrastColor } from '../theme/colors';
import theme from '../theme';
import useCarouselNav, { CarouselNavButtons } from './useCarouselNav';
import { Flex } from '../';

const CarouselStyled = styled(Swiper)`
  padding: 8px;

  .swiper-wrapper {
    margin-bottom: 50px;
  }

  .swiper-pagination-bullet {
    border-radius: 50px;
    width: 18px;
    height: 18px;
    transition: all 0.25s cubic-bezier(1, 0.06, 0.58, 1.2);
    opacity: ${(props) => props.$opacity};
    background: ${(props) => props.$unactiveColor};
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
    background: ${(props) => props.$activeColor};
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
`;

const getUnactiveColor = (userThemeColor, bgColor) => {
  if (bgColor && userThemeColor === bgColor) return getLighterThemeColor(userThemeColor);
  if (bgColor) return getUserThemeContrastColor(bgColor);
  return theme.colors.NEU_600;
};

const Carousel = ({ children, userThemeColor, bgColor, navigation = true, navColor, ...props }) => {
  const { navProps, swiperNavProps } = useCarouselNav();
  const showNav = navigation !== false;

  const swiperElement = (
    <CarouselStyled
      $activeColor={!!bgColor && userThemeColor !== bgColor ? getDarkerThemeColor(userThemeColor) : getUserThemeContrastColor(userThemeColor)}
      $unactiveColor={getUnactiveColor(userThemeColor, bgColor)}
      $opacity={0.5}
      modules={[Pagination, Autoplay, Navigation, Keyboard]}
      pagination={{ clickable: true }}
      keyboard={{ enabled: true }}
      navigation={false}
      slidesPerView={1}
      {...(showNav ? swiperNavProps : {})}
      {...props}
    >
      {React.Children.map(children, (child, i) => (
        <SwiperSlide key={i}>{child}</SwiperSlide>
      ))}
    </CarouselStyled>
  );

  if (!showNav) return swiperElement;

  return (
    <div style={{ width: '100%' }}>
      <Flex justify='flex-end' style={{ marginBottom: 12 }}>
        <CarouselNavButtons {...navProps} color={navColor} />
      </Flex>
      {swiperElement}
    </div>
  );
};

export { default as useCarouselNav, CarouselNavButtons } from './useCarouselNav';
export { default as ListCarousel } from './ListCarousel';
export default Carousel;
